import { render } from "./semester.vue?vue&type=template&id=3338ae3f"
import script from "./semester.vue?vue&type=script&lang=js"
export * from "./semester.vue?vue&type=script&lang=js"
script.render = render

export default script